export const TRUSTPILOT_REVIEW_URL = "https://www.trustpilot.com/review/gtsetu.com";

export {
  TRUSTPILOT_PROMPT_MILESTONES,
  isTrustpilotPromptMilestone,
  type TrustpilotPromptMilestone,
} from "@shared/trustpilot";
